<template>
    <v-card v-show="!hideFullCard" variant="outlined">
        <v-card-title>
            <v-icon start color="primary">mdi-star</v-icon>
            {{ $t('extra_services') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
            <div v-show="!hideMandatoryExtraServices">
                <v-row v-if="mandatoryExtraServices.length">
                    <v-col cols="12">
                        <h4 class="text-subtitle-1 font-weight-bold">
                            {{ $t('extra_services_included') }}
                        </h4>
                    </v-col>
                </v-row>
                <extra-service
                    v-for="(extraService, extraServiceIndex) in mandatoryExtraServices"
                    :key="`${extraServiceIndex}-mandatory`"
                    :extra-service="extraService"
                    :hide-action="!manualModification"
                />
            </div>
            <template v-if="optionalExtraServices.length">
                <v-row>
                    <v-col cols="12">
                        <h4 class="text-subtitle-1 font-weight-bold">
                            {{ $t('extra_services') }}
                        </h4>
                    </v-col>
                </v-row>
                <extra-service
                    v-for="(extraService, extraServiceIndex) in optionalExtraServices"
                    :key="`${extraServiceIndex}-optional`"
                    :extra-service="extraService"
                    :extra-services-for-request="extraServicesForRequest"
                    :hide-action="disabled"
                    :manual-modification="manualModification"
                    @update="update"
                >
                    <template v-slot:additional-options="slotProps">
                        <slot name="additional-options" v-bind="slotProps" />
                    </template>
                </extra-service>
            </template>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import ExtraService from '~src/components/booking/forms/fields/extraService.src'

    @Component({
        components: {ExtraService},
    })
    export class ExtraServicesForm extends Vue {
        @VModel({type: Array}) extraServicesForRequest
        @Prop({required: true}) additionalOptions
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) manualModification

        @Emit()
        update({service: {serviceRPH, id}, operation, qty, nettoPriceValue, bruttoPriceValue}) {
            const index = !this.manualModification
                ? this.extraServicesForRequest.findIndex(service => service.serviceRPH === serviceRPH)
                : this.extraServicesForRequest.findIndex(service => service.extraServiceId === +id)
            if (!operation) {
                this.extraServicesForRequest.splice(index, 1)
            } else {
                const service = !this.manualModification
                    ? {serviceRPH, quantity: +qty}
                    : {extraServiceId: +id, quantity: +qty, nettoPriceValue, bruttoPriceValue}
                if (index !== -1) {
                    this.extraServicesForRequest[index] = service
                } else {
                    this.extraServicesForRequest.push(service)
                }
            }
        }

        get optionalExtraServices() {
            return this.additionalOptions?.extraServices.filter(extraService => !extraService.mandatory) || []
        }

        get mandatoryExtraServices() {
            return this.additionalOptions?.extraServices.filter(extraService => extraService.mandatory)
        }

        get hideMandatoryExtraServices() {
            return false
        }

        get hideFullCard() {
            return this.hideMandatoryExtraServices && !this.optionalExtraServices.length
        }
    }

    export default ExtraServicesForm
</script>
